import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import BrandLogo from "@/components/BrandLogo";

export default function Footer() {
  const { t, settings } = useApp();
  return (
    <footer className="mt-24 border-t border-border/60 bg-secondary text-secondary-foreground">
      <div className="container-x grid grid-cols-2 gap-10 py-16 md:grid-cols-4">
        <div className="col-span-2">
          <BrandLogo className="text-secondary-foreground" />
          <p className="mt-4 max-w-md text-sm text-secondary-foreground/70">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <div className="mb-3 text-xs font-semibold uppercase tracking-[0.24em] text-accent">
            {t("nav.menu")}
          </div>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-menu" to="/menu" className="hover:text-accent">{t("nav.menu")}</Link></li>
            <li><Link data-testid="footer-link-packages" to="/packages" className="hover:text-accent">{t("nav.packages")}</Link></li>
            <li><Link data-testid="footer-link-build" to="/build" className="hover:text-accent">{t("nav.build")}</Link></li>
            <li><Link data-testid="footer-link-quote" to="/quote" className="hover:text-accent">{t("nav.quote")}</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-accent">{t("nav.contact")}</Link></li>
            <li><Link data-testid="footer-link-terms" to="/terms" className="hover:text-accent">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
        <div>
          <div className="mb-3 text-xs font-semibold uppercase tracking-[0.24em] text-accent">
            {t("contact.title")}
          </div>
          <ul className="space-y-2 text-sm text-secondary-foreground/80" data-testid="footer-contact-block">
            <li>
              {t("contact.phone")}:{" "}
              {settings?.contact_phone ? (
                <a href={`tel:${String(settings.contact_phone).replace(/[^\d+]/g, "")}`} data-testid="footer-phone-link">
                  {settings.contact_phone}
                </a>
              ) : (
                t("contact.not_configured")
              )}
            </li>
            <li>{t("contact.email")}: {settings?.contact_email || t("contact.not_configured")}</li>
            <li>{t("contact.address")}: {settings?.address || t("contact.not_configured")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-secondary-foreground/10">
        <div className="container-x flex flex-col items-start justify-between gap-2 py-6 text-xs text-secondary-foreground/60 sm:flex-row sm:pr-44">
          <span>{t("footer.made_with")}</span>
          <Link data-testid="footer-admin-link" to="/admin/login" className="hover:text-accent">
            {t("nav.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
